import styles from "./Label.module.scss";

interface ILabelProps {
    /**
    * The `id` of the input element this label is associated with.
    */
    htmlFor: string;

    /**
    * The text content of the label.
    */
    label: string;

    /**
    * To indicate whether the field is required. If true, displays a red asterisk next to the label.
    */
    required?: boolean;
}

/**
 * The label.
 * @param {ILabelProps} param The props used to render the label.
 * @returns The rendered component.
 */
function Label({
    htmlFor,
    label,
    required
}: Readonly<ILabelProps>): JSX.Element {
    return (
        <label
            className={styles.label}
            htmlFor={htmlFor}
        >
            {label} {required && <span aria-hidden={true} className={styles.required}>*</span>}
        </label>
    );
}

export { Label };
